
import { Box, Checkbox, Typography, TextField, FormHelperText, Stack, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";

function MqttOut({ row, onChange }) {
    const [useExternal, setUseExternal] = useState(false);
    const [useSsl, setUseSsl] = useState(row.useSsl);

    const handleChange = (event) => {
        setUseExternal(!useExternal);
    };

    // prevent warnings on setting checked for "controlled" elements
    const setChecked = (check) => {
        return { value: check }
    };

    const handleClick = (event) => {
        if (!event.target.checked) {
            row.endPoint = "";
            row.port = "";
            row.userName = "";
            row.password = "";
        }
    };

    const handleSslClicked = (event) => {
        row.useSsl = event.target.checked;
        setUseSsl(row.useSsl);
    };

    useEffect(() => {
        if (row.endPoint != null && row.endPoint !== "") {
            setUseExternal(true);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Box sx={{ display: "flex", mt: 2 }} spacing={2}>
                <Typography sx={{ fontWeight: "bold" }}>MQTT Parameters - OUT</Typography>
            </Box>
            <Box sx={{ display: "flex", mt: 1, mb: -1, gap: 3 }}>
                <FormControlLabel checked={useExternal} control={
                    <Checkbox onChange={handleChange}
                        checked={setChecked(useExternal).value}
                        onClick={handleClick} />
                } label="Use external broker" />

                <FormControlLabel control={
                    <Checkbox 
                        checked={useSsl}
                        onClick={handleSslClicked} />
                    } 
                    label="Use SSL" 
                />
            </Box>
            <Box sx={{ display: "flex" }} spacing={2}>
                <Stack sx={{ width: 0.5, mr: 2 }}>
                    <TextField
                        required={useExternal}
                        disabled={!useExternal}
                        margin="dense"
                        id="endPoint"
                        name="endPoint"
                        label="End Point"
                        type="text"
                        defaultValue={row.endPoint}
                        onChange={onChange}
                        variant="standard"
                        aria-describedby="endpoint-helper-text"
                    />
                    <FormHelperText id="endpoint-helper-text">
                        External broker address.
                    </FormHelperText>
                </Stack>
                <Stack sx={{ width: 100, mr: 2 }}>
                    <TextField
                        required={useExternal}
                        disabled={!useExternal}
                        margin="dense"
                        id="port"
                        name="port"
                        label="Port"
                        type="number"
                        defaultValue={row.port}
                        onChange={onChange}
                        variant="standard"
                    />
                </Stack>
                <Stack sx={{ width: 100, flexGrow: 1 }}>
                    <TextField
                        required
                        margin="dense"
                        id="source"
                        name="source"
                        label="Topic"
                        type="text"
                        defaultValue={row.source}
                        onChange={onChange}
                        variant="standard"
                        aria-describedby="source-helper-text"
                    />
                    <FormHelperText id="source-helper-text">
                        Send messages to this broker topic.
                    </FormHelperText>
                </Stack>
            </Box>
            <Box sx={{ display: "flex" }} spacing={2}>
                <TextField sx={{ width: 0.31, mr: 2 }}
                    required={useExternal}
                    disabled={!useExternal}
                    margin="dense"
                    id="userName"
                    name="userName"
                    label="User Name"
                    type="text"
                    defaultValue={row.userName}
                    onChange={onChange}
                    variant="standard" />
                <TextField sx={{ width: 0.31, mr: 2 }}
                    required={useExternal}
                    disabled={!useExternal}
                    margin="dense"
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    defaultValue={row.password}
                    onChange={onChange}
                    variant="standard" />
            </Box>
            <Box sx={{ display: "flex" }} spacing={2}>
                <Stack sx={{ width: 0.64 }}>
                    <TextField
                        margin="dense"
                        id="topic"
                        name="topic"
                        label="Trigger Topic"
                        type="text"
                        defaultValue={row.topic}
                        onChange={onChange}
                        variant="standard"
                        aria-describedby="topic-helper-text"
                    />
                    <FormHelperText id="topic-helper-text">
                        Send messages triggered by this ESB topic.
                    </FormHelperText>
                </Stack>
            </Box>
            <Box sx={{ display: "flex" }} spacing={2}>
                <Stack sx={{ flexGrow: 1 }}>
                    <TextField
                        margin="dense"
                        id="body"
                        name="body"
                        label="Message Body"
                        type="text"
                        rows={4}
                        multiline
                        defaultValue={row.body}
                        onChange={onChange}
                        variant="standard"
                        aria-describedby="body-helper-text"
                    />
                    <FormHelperText id="response-helper-text">
                        (Optional) For heartbeats: send this message to the broker topic.
                    </FormHelperText>
                </Stack>
            </Box>
            <Box sx={{ display: "flex", mt: 1 }} spacing={2}>
                <Stack sx={{ width: 200, mr: 2 }}>
                    <TextField
                        margin="dense"
                        id="interval"
                        name="interval"
                        label="Interval (ms)"
                        type="number"
                        defaultValue={row.interval}
                        onChange={onChange}
                        variant="standard"
                        aria-describedby="interval-helper-text"
                    />
                    <FormHelperText id="interval-helper-text">
                        (Optional) For heartbeats.
                    </FormHelperText>
                </Stack>
                <Stack sx={{ flexGrow: 1 }}>
                    <TextField
                        margin="dense"
                        id="outTopic"
                        name="outTopic"
                        label="Message Topic"
                        type="text"
                        defaultValue={row.outTopic}
                        onChange={onChange}
                        variant="standard"
                        aria-describedby="outTopic-helper-text"
                    />
                    <FormHelperText id="outTopic-helper-text">
                        (Optional) Log activity to this ESB topic.
                    </FormHelperText>
                </Stack>
            </Box>
        </>
    );
};

export default MqttOut;